import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "screen" }
const _hoisted_2 = {
  key: 0,
  class: "stack"
}
const _hoisted_3 = { class: "card" }
const _hoisted_4 = {
  key: 0,
  class: "responsive-grid"
}
const _hoisted_5 = { class: "muted" }
const _hoisted_6 = { class: "simple-list" }
const _hoisted_7 = {
  key: 1,
  class: "muted"
}
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "split" }
const _hoisted_10 = { class: "muted" }
const _hoisted_11 = { class: "data-table" }
const _hoisted_12 = {
  key: 1,
  class: "muted"
}
const _hoisted_13 = { class: "card" }
const _hoisted_14 = {
  key: 0,
  class: "data-table"
}
const _hoisted_15 = {
  key: 1,
  class: "muted"
}
const _hoisted_16 = {
  key: 1,
  class: "two-column"
}
const _hoisted_17 = { class: "split" }
const _hoisted_18 = { type: "submit" }
const _hoisted_19 = { class: "card" }
const _hoisted_20 = { class: "data-table" }
const _hoisted_21 = { class: "actions" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 2,
  class: "two-column"
}
const _hoisted_25 = { class: "split" }
const _hoisted_26 = { type: "submit" }
const _hoisted_27 = { class: "card" }
const _hoisted_28 = { class: "data-table" }
const _hoisted_29 = { class: "actions" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 3,
  class: "stack"
}
const _hoisted_33 = { class: "three-column" }
const _hoisted_34 = { class: "split" }
const _hoisted_35 = ["value"]
const _hoisted_36 = { type: "submit" }
const _hoisted_37 = { class: "split" }
const _hoisted_38 = ["value"]
const _hoisted_39 = { type: "submit" }
const _hoisted_40 = { class: "card" }
const _hoisted_41 = {
  key: 0,
  class: "stack"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "stack" }
const _hoisted_44 = { class: "actions" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "simple-list" }
const _hoisted_49 = { class: "muted" }
const _hoisted_50 = { class: "actions" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 1,
  class: "muted"
}
const _hoisted_55 = {
  key: 4,
  class: "two-column"
}
const _hoisted_56 = { class: "stack" }
const _hoisted_57 = { class: "split" }
const _hoisted_58 = { type: "submit" }
const _hoisted_59 = { class: "responsive-grid" }
const _hoisted_60 = { class: "split" }
const _hoisted_61 = { class: "muted" }
const _hoisted_62 = { class: "muted" }
const _hoisted_63 = { class: "actions" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { class: "badge-list" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = {
  key: 0,
  class: "stack assignment-box"
}
const _hoisted_70 = ["value"]
const _hoisted_71 = { class: "muted" }
const _hoisted_72 = { class: "actions" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { class: "card stack" }
const _hoisted_75 = { class: "actions" }
const _hoisted_76 = ["onClick"]
const _hoisted_77 = ["onClick"]
const _hoisted_78 = {
  key: 5,
  class: "stack"
}
const _hoisted_79 = { class: "two-column" }
const _hoisted_80 = { class: "split" }
const _hoisted_81 = ["value"]
const _hoisted_82 = ["value"]
const _hoisted_83 = { type: "submit" }
const _hoisted_84 = { class: "card stack" }
const _hoisted_85 = { class: "card" }
const _hoisted_86 = { class: "data-table" }
const _hoisted_87 = { class: "actions" }
const _hoisted_88 = ["onClick"]
const _hoisted_89 = ["onClick"]
const _hoisted_90 = ["onClick"]
const _hoisted_91 = {
  key: 6,
  class: "two-column"
}
const _hoisted_92 = { class: "split" }
const _hoisted_93 = ["value"]
const _hoisted_94 = { type: "submit" }
const _hoisted_95 = { id: "customer-names" }
const _hoisted_96 = ["value"]
const _hoisted_97 = { class: "card stack" }
const _hoisted_98 = { class: "split" }
const _hoisted_99 = { class: "actions" }
const _hoisted_100 = ["onClick"]
const _hoisted_101 = ["onClick"]
const _hoisted_102 = { class: "badge-list" }
const _hoisted_103 = {
  key: 0,
  class: "badge-list__item"
}
const _hoisted_104 = {
  key: 1,
  class: "badge-list__item"
}
const _hoisted_105 = {
  key: 2,
  class: "badge-list__item"
}
const _hoisted_106 = {
  key: 3,
  class: "badge-list__item"
}
const _hoisted_107 = {
  key: 7,
  class: "stack"
}
const _hoisted_108 = { class: "two-column" }
const _hoisted_109 = { class: "split" }
const _hoisted_110 = ["value"]
const _hoisted_111 = ["value"]
const _hoisted_112 = { type: "submit" }
const _hoisted_113 = {
  key: 0,
  class: "card stack"
}
const _hoisted_114 = ["value"]
const _hoisted_115 = { class: "actions" }
const _hoisted_116 = { class: "card" }
const _hoisted_117 = { class: "data-table" }
const _hoisted_118 = { class: "status-pill" }
const _hoisted_119 = { class: "actions" }
const _hoisted_120 = ["onClick"]
const _hoisted_121 = ["onClick"]
const _hoisted_122 = ["onClick"]
const _hoisted_123 = ["onClick"]
const _hoisted_124 = ["onClick"]
const _hoisted_125 = ["onClick"]
const _hoisted_126 = ["onClick"]
const _hoisted_127 = {
  key: 8,
  class: "stack"
}
const _hoisted_128 = {
  key: 0,
  class: "stack"
}
const _hoisted_129 = { class: "card" }
const _hoisted_130 = { class: "split" }
const _hoisted_131 = { class: "muted" }
const _hoisted_132 = { class: "actions" }
const _hoisted_133 = { class: "card split" }
const _hoisted_134 = { class: "muted" }
const _hoisted_135 = {
  key: 0,
  class: "success-callout"
}
const _hoisted_136 = {
  key: 1,
  class: "card"
}
const _hoisted_137 = { class: "split" }
const _hoisted_138 = { class: "muted" }
const _hoisted_139 = { class: "checkbox-row" }
const _hoisted_140 = ["checked", "onChange"]
const _hoisted_141 = {
  key: 0,
  class: "muted"
}
const _hoisted_142 = ["value", "onInput"]
const _hoisted_143 = {
  key: 1,
  class: "two-column"
}
const _hoisted_144 = { class: "soft-card stack" }
const _hoisted_145 = { class: "muted" }
const _hoisted_146 = { class: "muted" }
const _hoisted_147 = { class: "muted" }
const _hoisted_148 = ["value"]
const _hoisted_149 = ["value"]
const _hoisted_150 = ["value"]
const _hoisted_151 = { class: "muted" }
const _hoisted_152 = ["disabled"]
const _hoisted_153 = { class: "card stack" }
const _hoisted_154 = {
  key: 0,
  class: "muted"
}
const _hoisted_155 = {
  key: 9,
  class: "stack"
}
const _hoisted_156 = { class: "two-column" }
const _hoisted_157 = { class: "card stack" }
const _hoisted_158 = {
  key: 0,
  class: "card stack"
}
const _hoisted_159 = { class: "split" }
const _hoisted_160 = { class: "status-pill" }
const _hoisted_161 = { class: "actions" }
const _hoisted_162 = {
  key: 0,
  class: "stack"
}
const _hoisted_163 = { class: "muted" }
const _hoisted_164 = {
  key: 1,
  class: "muted"
}
const _hoisted_165 = { class: "card" }
const _hoisted_166 = { class: "data-table" }
const _hoisted_167 = { class: "actions" }
const _hoisted_168 = ["onClick"]
const _hoisted_169 = ["onClick"]
const _hoisted_170 = ["onClick"]
const _hoisted_171 = ["onClick"]
const _hoisted_172 = {
  key: 10,
  class: "two-column"
}
const _hoisted_173 = { class: "split" }
const _hoisted_174 = { type: "submit" }
const _hoisted_175 = { class: "card" }
const _hoisted_176 = { class: "data-table" }
const _hoisted_177 = { class: "actions" }
const _hoisted_178 = ["onClick"]
const _hoisted_179 = ["onClick"]
const _hoisted_180 = {
  key: 11,
  class: "stack"
}
const _hoisted_181 = { class: "two-column" }
const _hoisted_182 = { class: "split" }
const _hoisted_183 = { type: "submit" }
const _hoisted_184 = { class: "card" }
const _hoisted_185 = { class: "data-table" }
const _hoisted_186 = ["value", "onInput"]
const _hoisted_187 = ["value", "onInput"]
const _hoisted_188 = ["value", "onInput"]
const _hoisted_189 = ["value", "onInput"]
const _hoisted_190 = ["checked", "onChange"]
const _hoisted_191 = { class: "actions" }
const _hoisted_192 = ["onClick"]
const _hoisted_193 = { class: "card" }
const _hoisted_194 = { class: "data-table" }
const _hoisted_195 = { class: "actions" }
const _hoisted_196 = ["onClick"]
const _hoisted_197 = ["onClick"]
const _hoisted_198 = {
  key: 12,
  class: "card stack"
}
const _hoisted_199 = { class: "docs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.screen === 'home')
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[86] || (_cache[86] = _createElementVNode("h2", null, "Customer Versions", -1)),
            (_ctx.customerVersionBuckets.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerVersionBuckets, (bucket) => {
                    return (_openBlock(), _createElementBlock("article", {
                      key: bucket.version,
                      class: "soft-card"
                    }, [
                      _createElementVNode("h3", null, _toDisplayString(bucket.version), 1),
                      _createElementVNode("p", _hoisted_5, _toDisplayString(bucket.customers.length) + " customers", 1),
                      _createElementVNode("ul", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bucket.customers, (customer) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: customer.id
                          }, _toDisplayString(customer.name), 1))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_7, "No customers yet."))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[88] || (_cache[88] = _createElementVNode("h2", null, "Next Ring Deployment", -1)),
            (_ctx.nextRingRecommendation)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.nextRingRecommendation.ring.name), 1),
                      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.nextRingRecommendation.ring.description || "No description"), 1)
                    ]),
                    _createElementVNode("span", {
                      class: "badge",
                      style: _normalizeStyle({ backgroundColor: _ctx.nextRingRecommendation.ring.color })
                    }, " Order " + _toDisplayString(_ctx.nextRingRecommendation.ring.order), 5)
                  ]),
                  _createElementVNode("table", _hoisted_11, [
                    _cache[87] || (_cache[87] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Customer"),
                        _createElementVNode("th", null, "Current Version"),
                        _createElementVNode("th", null, "Days Since Last Deploy")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nextRingRecommendation.customers, (customer) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: customer.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(customer.name), 1),
                          _createElementVNode("td", null, _toDisplayString(customer.currentVersion || "Unknown"), 1),
                          _createElementVNode("td", null, _toDisplayString(customer.daysSinceDeploy), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("p", _hoisted_12, "No rings with customers are available yet."))
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[90] || (_cache[90] = _createElementVNode("h2", null, "Upcoming Planned Deploys", -1)),
            (_ctx.upcomingPlanned.length)
              ? (_openBlock(), _createElementBlock("table", _hoisted_14, [
                  _cache[89] || (_cache[89] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Customer"),
                      _createElementVNode("th", null, "Versions"),
                      _createElementVNode("th", null, "Planned Date"),
                      _createElementVNode("th", null, "Assigned User"),
                      _createElementVNode("th", null, "Notes")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.upcomingPlanned, (planned) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: planned.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(planned.customerName), 1),
                        _createElementVNode("td", null, _toDisplayString(planned.currentVersion) + " -> " + _toDisplayString(planned.targetVersion), 1),
                        _createElementVNode("td", null, _toDisplayString(planned.plannedDate), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.getUserLabel(planned.assignedUserId)), 1),
                        _createElementVNode("td", null, _toDisplayString(planned.notes || "—"), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_15, "No planned deployments are scheduled."))
          ])
        ]))
      : (_ctx.screen === 'users')
        ? (_openBlock(), _createElementBlock("section", _hoisted_16, [
            _createElementVNode("form", {
              class: "card stack",
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitUser && _ctx.submitUser(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.userForm.id ? "Edit User" : "Create User"), 1),
                (_ctx.userForm.id)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "ghost",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetUserForm && _ctx.resetUserForm(...args)))
                    }, " Clear "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("label", null, [
                _cache[91] || (_cache[91] = _createTextVNode(" First name ", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userForm.name) = $event)),
                  required: ""
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.userForm.name,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createElementVNode("label", null, [
                _cache[92] || (_cache[92] = _createTextVNode(" Surname ", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userForm.surname) = $event)),
                  required: ""
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.userForm.surname,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createElementVNode("label", null, [
                _cache[93] || (_cache[93] = _createTextVNode(" Email ", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userForm.email) = $event)),
                  type: "email",
                  required: ""
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.userForm.email,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createElementVNode("button", _hoisted_18, _toDisplayString(_ctx.userForm.id ? "Update User" : "Save User"), 1)
            ], 32),
            _createElementVNode("div", _hoisted_19, [
              _cache[95] || (_cache[95] = _createElementVNode("h2", null, "Users", -1)),
              _createElementVNode("table", _hoisted_20, [
                _cache[94] || (_cache[94] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Name"),
                    _createElementVNode("th", null, "Email"),
                    _createElementVNode("th", null, "Actions")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedUsers, (user) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: user.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(user.name) + " " + _toDisplayString(user.surname), 1),
                      _createElementVNode("td", null, _toDisplayString(user.email), 1),
                      _createElementVNode("td", _hoisted_21, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "ghost",
                          onClick: ($event: any) => (_ctx.editUser(user))
                        }, " Edit ", 8, _hoisted_22),
                        _createElementVNode("button", {
                          type: "button",
                          class: "danger",
                          onClick: ($event: any) => (_ctx.removeUser(user.id))
                        }, " Delete ", 8, _hoisted_23)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        : (_ctx.screen === 'deploy-units')
          ? (_openBlock(), _createElementBlock("section", _hoisted_24, [
              _createElementVNode("form", {
                class: "card stack",
                onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitDeployUnit && _ctx.submitDeployUnit(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.deployUnitForm.id ? "Edit Deploy Unit" : "Create Deploy Unit"), 1),
                  (_ctx.deployUnitForm.id)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "ghost",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetDeployUnitForm && _ctx.resetDeployUnitForm(...args)))
                      }, " Clear "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("label", null, [
                  _cache[96] || (_cache[96] = _createTextVNode(" Name ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.deployUnitForm.name) = $event)),
                    required: ""
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.deployUnitForm.name,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[97] || (_cache[97] = _createTextVNode(" Description ", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.deployUnitForm.description) = $event)),
                    rows: "5"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.deployUnitForm.description,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("button", _hoisted_26, _toDisplayString(_ctx.deployUnitForm.id ? "Update Deploy Unit" : "Save Deploy Unit"), 1)
              ], 32),
              _createElementVNode("div", _hoisted_27, [
                _cache[99] || (_cache[99] = _createElementVNode("h2", null, "Deploy Units", -1)),
                _createElementVNode("table", _hoisted_28, [
                  _cache[98] || (_cache[98] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Name"),
                      _createElementVNode("th", null, "Description"),
                      _createElementVNode("th", null, "Created"),
                      _createElementVNode("th", null, "Actions")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedDeployUnits, (unit) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: unit.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(unit.name), 1),
                        _createElementVNode("td", null, _toDisplayString(unit.description || "—"), 1),
                        _createElementVNode("td", null, _toDisplayString(unit.createdAt.slice(0, 10)), 1),
                        _createElementVNode("td", _hoisted_29, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "ghost",
                            onClick: ($event: any) => (_ctx.editDeployUnit(unit))
                          }, " Edit ", 8, _hoisted_30),
                          _createElementVNode("button", {
                            type: "button",
                            class: "danger",
                            onClick: ($event: any) => (_ctx.removeDeployUnit(unit.id))
                          }, " Delete ", 8, _hoisted_31)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : (_ctx.screen === 'deploy-steps')
            ? (_openBlock(), _createElementBlock("section", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("form", {
                    class: "card stack",
                    onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitSection && _ctx.submitSection(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("h2", null, _toDisplayString(_ctx.sectionForm.id ? "Edit Section" : "Create Section"), 1),
                      (_ctx.sectionForm.id)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "ghost",
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.resetSectionForm && _ctx.resetSectionForm(...args)))
                          }, " Clear "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("label", null, [
                      _cache[100] || (_cache[100] = _createTextVNode(" Name ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.sectionForm.name) = $event)),
                        required: ""
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.sectionForm.name,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _cache[102] || (_cache[102] = _createTextVNode(" Deploy Unit ", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.sectionForm.deployUnitId) = $event)),
                        required: ""
                      }, [
                        _cache[101] || (_cache[101] = _createElementVNode("option", { value: "" }, "Select deploy unit", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedDeployUnits, (unit) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: unit.id,
                            value: unit.id
                          }, _toDisplayString(unit.name), 9, _hoisted_35))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.sectionForm.deployUnitId]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _cache[103] || (_cache[103] = _createTextVNode(" Position ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.sectionForm.position) = $event)),
                        type: "number",
                        min: "1",
                        required: ""
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.sectionForm.position,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("button", _hoisted_36, _toDisplayString(_ctx.sectionForm.id ? "Update Section" : "Save Section"), 1)
                  ], 32),
                  _createElementVNode("form", {
                    class: "card stack",
                    onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitStep && _ctx.submitStep(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("h2", null, _toDisplayString(_ctx.stepForm.id ? "Edit Step" : "Create Step"), 1),
                      (_ctx.stepForm.id)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "ghost",
                            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.resetStepForm && _ctx.resetStepForm(...args)))
                          }, " Clear "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("label", null, [
                      _cache[104] || (_cache[104] = _createTextVNode(" Name ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.stepForm.name) = $event)),
                        required: ""
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.stepForm.name,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _cache[105] || (_cache[105] = _createTextVNode(" Description ", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.stepForm.description) = $event)),
                        rows: "4"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.stepForm.description,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _cache[107] || (_cache[107] = _createTextVNode(" Section ", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.stepForm.sectionId) = $event)),
                        required: ""
                      }, [
                        _cache[106] || (_cache[106] = _createElementVNode("option", { value: "" }, "Select section", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedSections, (section) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: section.id,
                            value: section.id
                          }, _toDisplayString(_ctx.getDeployUnitLabel(section.deployUnitId)) + " / " + _toDisplayString(section.name), 9, _hoisted_38))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.stepForm.sectionId]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _cache[108] || (_cache[108] = _createTextVNode(" Position ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.stepForm.position) = $event)),
                        type: "number",
                        min: "1",
                        required: ""
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.stepForm.position,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("button", _hoisted_39, _toDisplayString(_ctx.stepForm.id ? "Update Step" : "Save Step"), 1)
                  ], 32),
                  _cache[109] || (_cache[109] = _createElementVNode("div", { class: "card stack" }, [
                    _createElementVNode("h2", null, "Library Guidance"),
                    _createElementVNode("p", { class: "muted" }, " Use the buttons in the library panels to create sections directly in a deploy unit, create steps directly in a section, or insert a step immediately after an existing step. ")
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _cache[110] || (_cache[110] = _createElementVNode("h2", null, "Deploy Step Library", -1)),
                  (_ctx.sortedDeployUnits.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedDeployUnits, (unit) => {
                          return (_openBlock(), _createElementBlock("details", {
                            key: unit.id,
                            open: "",
                            class: "details-panel"
                          }, [
                            _createElementVNode("summary", null, [
                              _createElementVNode("span", null, _toDisplayString(unit.name), 1),
                              _createElementVNode("button", {
                                type: "button",
                                class: "ghost",
                                onClick: _withModifiers(($event: any) => (_ctx.primeSectionForUnit(unit.id)), ["prevent"])
                              }, " Add Section ", 8, _hoisted_42)
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSectionsForUnit(unit.id), (section) => {
                                return (_openBlock(), _createElementBlock("details", {
                                  key: section.id,
                                  open: "",
                                  class: "details-panel details-panel--nested"
                                }, [
                                  _createElementVNode("summary", null, [
                                    _createElementVNode("span", null, _toDisplayString(section.position) + ". " + _toDisplayString(section.name), 1),
                                    _createElementVNode("span", _hoisted_44, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "ghost",
                                        onClick: _withModifiers(($event: any) => (_ctx.editSection(section)), ["prevent"])
                                      }, " Edit ", 8, _hoisted_45),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "ghost",
                                        onClick: _withModifiers(($event: any) => (_ctx.primeStepForSection(section.id)), ["prevent"])
                                      }, " Add Step ", 8, _hoisted_46),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "danger",
                                        onClick: _withModifiers(($event: any) => (_ctx.removeSection(section.id)), ["prevent"])
                                      }, " Delete ", 8, _hoisted_47)
                                    ])
                                  ]),
                                  _createElementVNode("ul", _hoisted_48, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getStepsForSection(section.id), (step) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: step.id
                                      }, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("strong", null, _toDisplayString(step.position) + ". " + _toDisplayString(step.name), 1),
                                          _createElementVNode("p", _hoisted_49, _toDisplayString(step.description || "No description"), 1)
                                        ]),
                                        _createElementVNode("span", _hoisted_50, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "ghost",
                                            onClick: ($event: any) => (_ctx.editStep(step))
                                          }, " Edit ", 8, _hoisted_51),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "ghost",
                                            onClick: ($event: any) => (_ctx.primeStepAfter(step))
                                          }, " Add After ", 8, _hoisted_52),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "danger",
                                            onClick: ($event: any) => (_ctx.removeStep(step.id))
                                          }, " Delete ", 8, _hoisted_53)
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_54, "Create deploy units first."))
                ])
              ]))
            : (_ctx.screen === 'rings')
              ? (_openBlock(), _createElementBlock("section", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("form", {
                      class: "card stack",
                      onSubmit: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitRing && _ctx.submitRing(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("h2", null, _toDisplayString(_ctx.ringForm.id ? "Edit Ring" : "Create Ring"), 1),
                        (_ctx.ringForm.id)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "ghost",
                              onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.resetRingForm && _ctx.resetRingForm(...args)))
                            }, " Clear "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("label", null, [
                        _cache[111] || (_cache[111] = _createTextVNode(" Name ", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.ringForm.name) = $event)),
                          required: ""
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.ringForm.name,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[112] || (_cache[112] = _createTextVNode(" Description ", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.ringForm.description) = $event)),
                          rows: "4"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.ringForm.description,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[113] || (_cache[113] = _createTextVNode(" Color ", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.ringForm.color) = $event)),
                          type: "color",
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.ringForm.color]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[114] || (_cache[114] = _createTextVNode(" Order ", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.ringForm.order) = $event)),
                          type: "number",
                          min: "1",
                          required: ""
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.ringForm.order,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("button", _hoisted_58, _toDisplayString(_ctx.ringForm.id ? "Update Ring" : "Save Ring"), 1)
                    ], 32),
                    _createElementVNode("div", _hoisted_59, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedRings, (ring) => {
                        return (_openBlock(), _createElementBlock("article", {
                          key: ring.id,
                          class: "card"
                        }, [
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", null, [
                              _createElementVNode("h2", null, _toDisplayString(ring.name), 1),
                              _createElementVNode("p", _hoisted_61, _toDisplayString(ring.description || "No description"), 1)
                            ]),
                            _createElementVNode("span", {
                              class: "color-dot",
                              style: _normalizeStyle({ backgroundColor: ring.color })
                            }, null, 4)
                          ]),
                          _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.getCustomersForRing(ring.id).length) + " assigned customers ", 1),
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "ghost",
                              onClick: ($event: any) => (_ctx.editRing(ring))
                            }, " Edit ", 8, _hoisted_64),
                            _createElementVNode("button", {
                              type: "button",
                              class: "danger",
                              onClick: ($event: any) => (_ctx.removeRing(ring.id))
                            }, " Delete ", 8, _hoisted_65),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ghost",
                              onClick: ($event: any) => (_ctx.openRingAssignment(ring.id))
                            }, " Assign Customers ", 8, _hoisted_66)
                          ]),
                          _createElementVNode("div", _hoisted_67, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCustomersForRing(ring.id), (customer) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: customer.id,
                                class: "badge-list__item"
                              }, [
                                _createTextVNode(_toDisplayString(customer.name) + " ", 1),
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.removeCustomerFromRing(customer.id))
                                }, " x ", 8, _hoisted_68)
                              ]))
                            }), 128))
                          ]),
                          (_ctx.ringAssignmentTargetId === ring.id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedCustomers, (customer) => {
                                  return (_openBlock(), _createElementBlock("label", {
                                    key: customer.id,
                                    class: "checkbox-row"
                                  }, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.ringAssignmentCustomerIds) = $event)),
                                      type: "checkbox",
                                      value: customer.id
                                    }, null, 8, _hoisted_70), [
                                      [_vModelCheckbox, _ctx.ringAssignmentCustomerIds]
                                    ]),
                                    _createElementVNode("span", null, [
                                      _createTextVNode(_toDisplayString(customer.name) + " ", 1),
                                      _createElementVNode("small", _hoisted_71, "(" + _toDisplayString(_ctx.getRingLabel(customer.ringId)) + ")", 1)
                                    ])
                                  ]))
                                }), 128)),
                                _createElementVNode("div", _hoisted_72, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.applyRingAssignment(ring.id))
                                  }, " Confirm Assignment ", 8, _hoisted_73),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "ghost",
                                    onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.cancelRingAssignment && _ctx.cancelRingAssignment(...args)))
                                  }, " Close ")
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _cache[115] || (_cache[115] = _createElementVNode("h2", null, "Ring Order", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedRings, (ring) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `order-${ring.id}`,
                        class: "split soft-card"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(ring.order) + ". " + _toDisplayString(ring.name), 1),
                        _createElementVNode("span", _hoisted_75, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "ghost",
                            onClick: ($event: any) => (_ctx.moveRing(ring.id, -1))
                          }, " Up ", 8, _hoisted_76),
                          _createElementVNode("button", {
                            type: "button",
                            class: "ghost",
                            onClick: ($event: any) => (_ctx.moveRing(ring.id, 1))
                          }, " Down ", 8, _hoisted_77)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : (_ctx.screen === 'customers')
                ? (_openBlock(), _createElementBlock("section", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("form", {
                        class: "card stack",
                        onSubmit: _cache[37] || (_cache[37] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitCustomer && _ctx.submitCustomer(...args)), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.customerForm.id ? "Edit Customer" : "Create Customer"), 1),
                          (_ctx.customerForm.id)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "ghost",
                                onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.resetCustomerForm && _ctx.resetCustomerForm(...args)))
                              }, " Clear "))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("label", null, [
                          _cache[116] || (_cache[116] = _createTextVNode(" Name ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.customerForm.name) = $event)),
                            required: ""
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.customerForm.name,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("label", null, [
                          _cache[117] || (_cache[117] = _createTextVNode(" Current Version ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.customerForm.currentVersion) = $event))
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.customerForm.currentVersion,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("label", null, [
                          _cache[118] || (_cache[118] = _createTextVNode(" Last Deploy Date ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.customerForm.lastDeployDate) = $event)),
                            type: "date"
                          }, null, 512), [
                            [_vModelText, _ctx.customerForm.lastDeployDate]
                          ])
                        ]),
                        _createElementVNode("label", null, [
                          _cache[119] || (_cache[119] = _createTextVNode(" Deployed By ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.customerForm.deployedBy) = $event))
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.customerForm.deployedBy,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("label", null, [
                          _cache[121] || (_cache[121] = _createTextVNode(" Ring Assignment ", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.customerForm.ringId) = $event))
                          }, [
                            _cache[120] || (_cache[120] = _createElementVNode("option", { value: "" }, "Unassigned", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedRings, (ring) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: ring.id,
                                value: ring.id
                              }, _toDisplayString(ring.name), 9, _hoisted_81))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.customerForm.ringId]
                          ])
                        ]),
                        _createElementVNode("label", null, [
                          _cache[122] || (_cache[122] = _createTextVNode(" Deploy Units ", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.customerForm.deployUnitIds) = $event)),
                            multiple: "",
                            size: "6"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedDeployUnits, (unit) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: unit.id,
                                value: unit.id
                              }, _toDisplayString(unit.name), 9, _hoisted_82))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.customerForm.deployUnitIds]
                          ])
                        ]),
                        _createElementVNode("label", null, [
                          _cache[123] || (_cache[123] = _createTextVNode(" Live Date ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.customerForm.liveDate) = $event)),
                            type: "date"
                          }, null, 512), [
                            [_vModelText, _ctx.customerForm.liveDate]
                          ])
                        ]),
                        _createElementVNode("label", null, [
                          _cache[124] || (_cache[124] = _createTextVNode(" DB Valid Date ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.customerForm.dbValidDate) = $event)),
                            type: "date"
                          }, null, 512), [
                            [_vModelText, _ctx.customerForm.dbValidDate]
                          ])
                        ]),
                        _createElementVNode("button", _hoisted_83, _toDisplayString(_ctx.customerForm.id ? "Update Customer" : "Save Customer"), 1)
                      ], 32),
                      _createElementVNode("div", _hoisted_84, [
                        _cache[126] || (_cache[126] = _createElementVNode("h2", null, "Customer Search", -1)),
                        _createElementVNode("label", null, [
                          _cache[125] || (_cache[125] = _createTextVNode(" Search ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.customerSearch) = $event)),
                            placeholder: "Search by customer, version, deploying user, or ring"
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.customerSearch,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_85, [
                      _cache[128] || (_cache[128] = _createElementVNode("h2", null, "Customers Overview", -1)),
                      _createElementVNode("table", _hoisted_86, [
                        _cache[127] || (_cache[127] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Customer"),
                            _createElementVNode("th", null, "Ring"),
                            _createElementVNode("th", null, "Deploy Units"),
                            _createElementVNode("th", null, "Current Version"),
                            _createElementVNode("th", null, "Last Deploy"),
                            _createElementVNode("th", null, "Live Date"),
                            _createElementVNode("th", null, "DB Valid Date"),
                            _createElementVNode("th", null, "Deployed By"),
                            _createElementVNode("th", null, "Deploy Count"),
                            _createElementVNode("th", null, "Status"),
                            _createElementVNode("th", null, "Actions")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerRows, (row) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: row.key
                            }, [
                              _createElementVNode("td", null, _toDisplayString(row.customerName), 1),
                              _createElementVNode("td", null, _toDisplayString(row.ringName), 1),
                              _createElementVNode("td", null, _toDisplayString(row.deployUnits.join(", ") || "—"), 1),
                              _createElementVNode("td", null, _toDisplayString(row.currentVersion || "Unknown"), 1),
                              _createElementVNode("td", null, _toDisplayString(row.lastDeployDate || "Never"), 1),
                              _createElementVNode("td", null, _toDisplayString(row.liveDate || "—"), 1),
                              _createElementVNode("td", null, _toDisplayString(row.dbValidDate || "—"), 1),
                              _createElementVNode("td", null, _toDisplayString(row.deployedBy || "—"), 1),
                              _createElementVNode("td", null, _toDisplayString(row.totalDeployCount), 1),
                              _createElementVNode("td", null, _toDisplayString(row.latestDeployStatus), 1),
                              _createElementVNode("td", _hoisted_87, [
                                (row.customer)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "ghost",
                                      onClick: ($event: any) => (_ctx.editCustomer(row.customer))
                                    }, " Edit ", 8, _hoisted_88))
                                  : _createCommentVNode("", true),
                                (row.customer)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "button",
                                      class: "danger",
                                      onClick: ($event: any) => (_ctx.removeCustomer(row.customer.id))
                                    }, " Delete ", 8, _hoisted_89))
                                  : _createCommentVNode("", true),
                                (row.latestDeploymentId)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      type: "button",
                                      class: "ghost",
                                      onClick: ($event: any) => (_ctx.openHistoryDeployment(row.latestDeploymentId))
                                    }, " Open Latest Deploy ", 8, _hoisted_90))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                : (_ctx.screen === 'notes')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_91, [
                      _createElementVNode("form", {
                        class: "card stack",
                        onSubmit: _cache[45] || (_cache[45] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitNote && _ctx.submitNote(...args)), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_92, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.noteForm.id ? "Edit Note" : "Create Note"), 1),
                          (_ctx.noteForm.id)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "ghost",
                                onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.resetNoteForm && _ctx.resetNoteForm(...args)))
                              }, " Clear "))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("label", null, [
                          _cache[129] || (_cache[129] = _createTextVNode(" Title ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.noteForm.title) = $event)),
                            required: ""
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.noteForm.title,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("label", null, [
                          _cache[130] || (_cache[130] = _createTextVNode(" Content ", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.noteForm.content) = $event)),
                            rows: "6",
                            required: ""
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.noteForm.content,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("label", null, [
                          _cache[131] || (_cache[131] = _createTextVNode(" Customer Name ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.noteForm.customerName) = $event)),
                            list: "customer-names"
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.noteForm.customerName,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("label", null, [
                          _cache[132] || (_cache[132] = _createTextVNode(" Target Version ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.noteForm.targetVersion) = $event))
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.noteForm.targetVersion,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("label", null, [
                          _cache[134] || (_cache[134] = _createTextVNode(" Deploy Unit ", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.noteForm.deployUnitId) = $event))
                          }, [
                            _cache[133] || (_cache[133] = _createElementVNode("option", { value: "" }, "All deploy units", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedDeployUnits, (unit) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: unit.id,
                                value: unit.id
                              }, _toDisplayString(unit.name), 9, _hoisted_93))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.noteForm.deployUnitId]
                          ])
                        ]),
                        _createElementVNode("button", _hoisted_94, _toDisplayString(_ctx.noteForm.id ? "Update Note" : "Save Note"), 1),
                        _createElementVNode("datalist", _hoisted_95, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedCustomers, (customer) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: customer.id,
                              value: customer.name
                            }, null, 8, _hoisted_96))
                          }), 128))
                        ])
                      ], 32),
                      _createElementVNode("div", _hoisted_97, [
                        _cache[135] || (_cache[135] = _createElementVNode("h2", null, "Future Deploy Notes", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedNotes, (note) => {
                          return (_openBlock(), _createElementBlock("article", {
                            key: note.id,
                            class: "soft-card stack"
                          }, [
                            _createElementVNode("div", _hoisted_98, [
                              _createElementVNode("h3", null, _toDisplayString(note.title), 1),
                              _createElementVNode("span", _hoisted_99, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "ghost",
                                  onClick: ($event: any) => (_ctx.editNote(note))
                                }, " Edit ", 8, _hoisted_100),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "danger",
                                  onClick: ($event: any) => (_ctx.removeNote(note.id))
                                }, " Delete ", 8, _hoisted_101)
                              ])
                            ]),
                            _createElementVNode("p", null, _toDisplayString(note.content), 1),
                            _createElementVNode("div", _hoisted_102, [
                              (
                !note.customerName && !note.targetVersion && !note.deployUnitId
              )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_103, " Applies everywhere "))
                                : _createCommentVNode("", true),
                              (note.customerName)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_104, " Customer: " + _toDisplayString(note.customerName), 1))
                                : _createCommentVNode("", true),
                              (note.targetVersion)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_105, " Version: " + _toDisplayString(note.targetVersion), 1))
                                : _createCommentVNode("", true),
                              (note.deployUnitId)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_106, " Unit: " + _toDisplayString(_ctx.getDeployUnitLabel(note.deployUnitId)), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : (_ctx.screen === 'planned')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_107, [
                        _createElementVNode("div", _hoisted_108, [
                          _createElementVNode("form", {
                            class: "card stack",
                            onSubmit: _cache[55] || (_cache[55] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitPlannedDeploy && _ctx.submitPlannedDeploy(...args)), ["prevent"]))
                          }, [
                            _createElementVNode("div", _hoisted_109, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.plannedForm.id ? "Edit Planned Deploy" : "Create Planned Deploy"), 1),
                              (_ctx.plannedForm.id)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "ghost",
                                    onClick: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.resetPlannedForm && _ctx.resetPlannedForm(...args)))
                                  }, " Clear "))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("label", null, [
                              _cache[137] || (_cache[137] = _createTextVNode(" Customer ", -1)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.plannedForm.customerName) = $event)),
                                required: "",
                                onChange: _cache[48] || (_cache[48] = 
//@ts-ignore
(...args) => (_ctx.syncPlannedCurrentVersion && _ctx.syncPlannedCurrentVersion(...args)))
                              }, [
                                _cache[136] || (_cache[136] = _createElementVNode("option", { value: "" }, "Select customer", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedCustomers, (customer) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: customer.id,
                                    value: customer.name
                                  }, _toDisplayString(customer.name), 9, _hoisted_110))
                                }), 128))
                              ], 544), [
                                [_vModelSelect, _ctx.plannedForm.customerName]
                              ])
                            ]),
                            _createElementVNode("label", null, [
                              _cache[138] || (_cache[138] = _createTextVNode(" Current Version ", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.plannedForm.currentVersion) = $event))
                              }, null, 512), [
                                [
                                  _vModelText,
                                  _ctx.plannedForm.currentVersion,
                                  void 0,
                                  { trim: true }
                                ]
                              ])
                            ]),
                            _createElementVNode("label", null, [
                              _cache[139] || (_cache[139] = _createTextVNode(" Target Version ", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.plannedForm.targetVersion) = $event)),
                                required: ""
                              }, null, 512), [
                                [
                                  _vModelText,
                                  _ctx.plannedForm.targetVersion,
                                  void 0,
                                  { trim: true }
                                ]
                              ])
                            ]),
                            _createElementVNode("label", null, [
                              _cache[140] || (_cache[140] = _createTextVNode(" Planned Date ", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.plannedForm.plannedDate) = $event)),
                                type: "date",
                                required: ""
                              }, null, 512), [
                                [_vModelText, _ctx.plannedForm.plannedDate]
                              ])
                            ]),
                            _createElementVNode("label", null, [
                              _cache[142] || (_cache[142] = _createTextVNode(" Assigned User ", -1)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.plannedForm.assignedUserId) = $event))
                              }, [
                                _cache[141] || (_cache[141] = _createElementVNode("option", { value: "" }, "Unassigned", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedUsers, (user) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: user.id,
                                    value: user.id
                                  }, _toDisplayString(user.name) + " " + _toDisplayString(user.surname), 9, _hoisted_111))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, _ctx.plannedForm.assignedUserId]
                              ])
                            ]),
                            _createElementVNode("label", null, [
                              _cache[143] || (_cache[143] = _createTextVNode(" Notes ", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.plannedForm.notes) = $event)),
                                rows: "4"
                              }, null, 512), [
                                [
                                  _vModelText,
                                  _ctx.plannedForm.notes,
                                  void 0,
                                  { trim: true }
                                ]
                              ])
                            ]),
                            _createElementVNode("label", null, [
                              _cache[145] || (_cache[145] = _createTextVNode(" Status ", -1)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.plannedForm.status) = $event))
                              }, [...(_cache[144] || (_cache[144] = [
                                _createElementVNode("option", { value: "planned" }, "planned", -1),
                                _createElementVNode("option", { value: "in-progress" }, "in-progress", -1),
                                _createElementVNode("option", { value: "completed" }, "completed", -1),
                                _createElementVNode("option", { value: "cancelled" }, "cancelled", -1)
                              ]))], 512), [
                                [_vModelSelect, _ctx.plannedForm.status]
                              ])
                            ]),
                            _createElementVNode("button", _hoisted_112, _toDisplayString(_ctx.plannedForm.id ? "Update Planned Deploy" : "Save Planned Deploy"), 1)
                          ], 32),
                          (_ctx.activeReminderPlanned)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                _cache[149] || (_cache[149] = _createElementVNode("h2", null, "Reminder Simulator", -1)),
                                _createElementVNode("p", null, _toDisplayString(_ctx.activeReminderPlanned.customerName) + " / " + _toDisplayString(_ctx.activeReminderPlanned.targetVersion), 1),
                                _createElementVNode("label", null, [
                                  _cache[146] || (_cache[146] = _createTextVNode(" Recipients ", -1)),
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.reminderUserIds) = $event)),
                                    multiple: "",
                                    size: "6"
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedUsers, (user) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: user.id,
                                        value: user.id
                                      }, _toDisplayString(user.name) + " " + _toDisplayString(user.surname), 9, _hoisted_114))
                                    }), 128))
                                  ], 512), [
                                    [_vModelSelect, _ctx.reminderUserIds]
                                  ])
                                ]),
                                _createElementVNode("label", null, [
                                  _cache[147] || (_cache[147] = _createTextVNode(" Additional Emails ", -1)),
                                  _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.reminderExtraEmails) = $event)),
                                    rows: "3",
                                    placeholder: "one@example.com, two@example.com"
                                  }, null, 512), [
                                    [
                                      _vModelText,
                                      _ctx.reminderExtraEmails,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                                ]),
                                _createElementVNode("label", null, [
                                  _cache[148] || (_cache[148] = _createTextVNode(" Message Body ", -1)),
                                  _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.reminderMessage) = $event)),
                                    rows: "5"
                                  }, null, 512), [
                                    [
                                      _vModelText,
                                      _ctx.reminderMessage,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_115, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[59] || (_cache[59] = 
//@ts-ignore
(...args) => (_ctx.sendReminder && _ctx.sendReminder(...args)))
                                  }, "Send Reminder"),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "ghost",
                                    onClick: _cache[60] || (_cache[60] = 
//@ts-ignore
(...args) => (_ctx.closeReminder && _ctx.closeReminder(...args)))
                                  }, " Close ")
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_116, [
                          _cache[151] || (_cache[151] = _createElementVNode("div", { class: "split" }, [
                            _createElementVNode("h2", null, "Planned Deploys"),
                            _createElementVNode("p", { class: "muted" }, "Sorted by planned date, undated last.")
                          ], -1)),
                          _createElementVNode("table", _hoisted_117, [
                            _cache[150] || (_cache[150] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "Customer"),
                                _createElementVNode("th", null, "Current"),
                                _createElementVNode("th", null, "Target"),
                                _createElementVNode("th", null, "Date"),
                                _createElementVNode("th", null, "Assigned"),
                                _createElementVNode("th", null, "Status"),
                                _createElementVNode("th", null, "Actions")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedPlannedDeploys, (planned) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: planned.id
                                }, [
                                  _createElementVNode("td", null, _toDisplayString(planned.customerName), 1),
                                  _createElementVNode("td", null, _toDisplayString(planned.currentVersion || "—"), 1),
                                  _createElementVNode("td", null, _toDisplayString(planned.targetVersion), 1),
                                  _createElementVNode("td", null, _toDisplayString(planned.plannedDate || "Undated"), 1),
                                  _createElementVNode("td", null, _toDisplayString(planned.assignedUserId
                    ? _ctx.getUserLabel(planned.assignedUserId)
                    : "Unassigned"), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_118, _toDisplayString(planned.status), 1)
                                  ]),
                                  _createElementVNode("td", _hoisted_119, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "ghost",
                                      onClick: ($event: any) => (_ctx.editPlannedDeploy(planned))
                                    }, " Edit ", 8, _hoisted_120),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "ghost",
                                      onClick: ($event: any) => (_ctx.openReminder(planned.id))
                                    }, " Reminder ", 8, _hoisted_121),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "ghost",
                                      onClick: ($event: any) => (_ctx.markPlannedCompleted(planned.id))
                                    }, " Complete ", 8, _hoisted_122),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "ghost",
                                      onClick: ($event: any) => (_ctx.markPlannedCancelled(planned.id))
                                    }, " Cancel ", 8, _hoisted_123),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "ghost",
                                      onClick: ($event: any) => (_ctx.reopenPlanned(planned.id))
                                    }, " Reopen ", 8, _hoisted_124),
                                    _createElementVNode("button", {
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.startPlanned(planned.id))
                                    }, " Start ", 8, _hoisted_125),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "danger",
                                      onClick: ($event: any) => (_ctx.removePlannedDeploy(planned.id))
                                    }, " Delete ", 8, _hoisted_126)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]))
                    : (_ctx.screen === 'deploy')
                      ? (_openBlock(), _createElementBlock("section", _hoisted_127, [
                          (_ctx.activeDeployment)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                _createElementVNode("div", _hoisted_129, [
                                  _createElementVNode("div", _hoisted_130, [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("h2", null, _toDisplayString(_ctx.activeDeployment.customerName), 1),
                                      _createElementVNode("p", _hoisted_131, _toDisplayString(_ctx.activeDeployment.currentVersion) + " -> " + _toDisplayString(_ctx.activeDeployment.targetVersion), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_132, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "ghost",
                                        onClick: _cache[61] || (_cache[61] = 
//@ts-ignore
(...args) => (_ctx.leaveActiveDeployment && _ctx.leaveActiveDeployment(...args)))
                                      }, " Back to Form "),
                                      _createElementVNode("button", {
                                        type: "button",
                                        onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.printDeployment(_ctx.activeDeployment.id)))
                                      }, " Print / PDF ")
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_133, [
                                  _createElementVNode("div", null, [
                                    _cache[152] || (_cache[152] = _createElementVNode("h3", null, "Progress", -1)),
                                    _createElementVNode("p", _hoisted_134, _toDisplayString(_ctx.activeDeploymentProgress.completed) + " / " + _toDisplayString(_ctx.activeDeploymentProgress.total) + " steps completed ", 1)
                                  ]),
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.activeDeploymentProgress.percentage) + "%", 1)
                                ]),
                                (_ctx.activeDeploymentProgress.status === 'completed')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_135, " All deployment steps are completed. "))
                                  : _createCommentVNode("", true),
                                (!_ctx.activeDeploymentGroups.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_136, [...(_cache[153] || (_cache[153] = [
                                      _createElementVNode("p", null, "This deployment has zero applicable steps.", -1)
                                    ]))]))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeDeploymentGroups, (group) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: group.key,
                                    class: "card stack"
                                  }, [
                                    _createElementVNode("div", _hoisted_137, [
                                      _createElementVNode("h3", null, _toDisplayString(group.unitName), 1),
                                      _createElementVNode("span", _hoisted_138, _toDisplayString(_ctx.getUnitNotesForDeployment(group.key).length) + " matching notes", 1)
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUnitNotesForDeployment(group.key), (note) => {
                                      return (_openBlock(), _createElementBlock("article", {
                                        key: note.id,
                                        class: "soft-card note-card"
                                      }, [
                                        _createElementVNode("strong", null, _toDisplayString(note.title), 1),
                                        _createElementVNode("p", null, _toDisplayString(note.content), 1)
                                      ]))
                                    }), 128)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.sections, (section) => {
                                      return (_openBlock(), _createElementBlock("details", {
                                        key: section.key,
                                        open: "",
                                        class: "details-panel"
                                      }, [
                                        _createElementVNode("summary", null, _toDisplayString(section.sectionName), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.steps, (step) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: step.state.stepId,
                                            class: "step-row"
                                          }, [
                                            _createElementVNode("label", _hoisted_139, [
                                              _createElementVNode("input", {
                                                checked: step.state.completed,
                                                type: "checkbox",
                                                onChange: ($event: any) => (
                    _ctx.toggleDeploymentStep(
                      _ctx.activeDeployment.id,
                      step.state.stepId,
                      _ctx.eventChecked($event)
                    )
                  )
                                              }, null, 40, _hoisted_140),
                                              _createElementVNode("span", null, [
                                                _createElementVNode("strong", null, _toDisplayString(step.stepName), 1),
                                                (step.stepDescription)
                                                  ? (_openBlock(), _createElementBlock("small", _hoisted_141, _toDisplayString(step.stepDescription), 1))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            _createElementVNode("textarea", {
                                              value: step.state.notes,
                                              rows: "3",
                                              placeholder: "Step notes",
                                              onInput: ($event: any) => (
                  _ctx.updateDeploymentStepNotes(
                    _ctx.activeDeployment.id,
                    step.state.stepId,
                    _ctx.eventValue($event)
                  )
                )
                                            }, null, 40, _hoisted_142)
                                          ]))
                                        }), 128))
                                      ]))
                                    }), 128))
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_143, [
                                _createElementVNode("form", {
                                  class: "card stack",
                                  onSubmit: _cache[69] || (_cache[69] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitDeployment && _ctx.submitDeployment(...args)), ["prevent"]))
                                }, [
                                  _cache[163] || (_cache[163] = _createElementVNode("h2", null, "Start New Deployment", -1)),
                                  _createElementVNode("div", _hoisted_144, [
                                    _cache[154] || (_cache[154] = _createElementVNode("strong", null, "Preconditions", -1)),
                                    _createElementVNode("p", _hoisted_145, "Users: " + _toDisplayString(_ctx.state.data.users.length), 1),
                                    _createElementVNode("p", _hoisted_146, "Customers: " + _toDisplayString(_ctx.state.data.customers.length), 1),
                                    _createElementVNode("p", _hoisted_147, "Steps: " + _toDisplayString(_ctx.state.data.steps.length), 1)
                                  ]),
                                  _createElementVNode("label", null, [
                                    _cache[156] || (_cache[156] = _createTextVNode(" Customer ", -1)),
                                    _withDirectives(_createElementVNode("select", {
                                      "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.deployForm.customerId) = $event)),
                                      required: "",
                                      onChange: _cache[64] || (_cache[64] = 
//@ts-ignore
(...args) => (_ctx.syncDeployCurrentVersion && _ctx.syncDeployCurrentVersion(...args)))
                                    }, [
                                      _cache[155] || (_cache[155] = _createElementVNode("option", { value: "" }, "Select customer", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedCustomers, (customer) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: customer.id,
                                          value: customer.id
                                        }, _toDisplayString(customer.name), 9, _hoisted_148))
                                      }), 128))
                                    ], 544), [
                                      [_vModelSelect, _ctx.deployForm.customerId]
                                    ])
                                  ]),
                                  _createElementVNode("label", null, [
                                    _cache[157] || (_cache[157] = _createTextVNode(" Current Version ", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.deployForm.currentVersion) = $event)),
                                      required: ""
                                    }, null, 512), [
                                      [
                                        _vModelText,
                                        _ctx.deployForm.currentVersion,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ])
                                  ]),
                                  _createElementVNode("label", null, [
                                    _cache[158] || (_cache[158] = _createTextVNode(" Target Version ", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.deployForm.targetVersion) = $event)),
                                      required: ""
                                    }, null, 512), [
                                      [
                                        _vModelText,
                                        _ctx.deployForm.targetVersion,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ])
                                  ]),
                                  _createElementVNode("label", null, [
                                    _cache[160] || (_cache[160] = _createTextVNode(" Deploying User ", -1)),
                                    _withDirectives(_createElementVNode("select", {
                                      "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.deployForm.userId) = $event)),
                                      required: ""
                                    }, [
                                      _cache[159] || (_cache[159] = _createElementVNode("option", { value: "" }, "Select user", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedUsers, (user) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: user.id,
                                          value: user.id
                                        }, _toDisplayString(user.name) + " " + _toDisplayString(user.surname), 9, _hoisted_149))
                                      }), 128))
                                    ], 512), [
                                      [_vModelSelect, _ctx.deployForm.userId]
                                    ])
                                  ]),
                                  _createElementVNode("label", null, [
                                    _cache[162] || (_cache[162] = _createTextVNode(" Branch ", -1)),
                                    _withDirectives(_createElementVNode("select", {
                                      "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.deployForm.branchId) = $event))
                                    }, [
                                      _cache[161] || (_cache[161] = _createElementVNode("option", { value: "" }, "No branch", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedBranches, (branch) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: branch.id,
                                          value: branch.id
                                        }, _toDisplayString(branch.name), 9, _hoisted_150))
                                      }), 128))
                                    ], 512), [
                                      [_vModelSelect, _ctx.deployForm.branchId]
                                    ])
                                  ]),
                                  _createElementVNode("p", _hoisted_151, "Applicable steps: " + _toDisplayString(_ctx.deployPreviewStepCount), 1),
                                  _createElementVNode("button", {
                                    type: "submit",
                                    disabled: !_ctx.canStartDeployment
                                  }, " Start Deployment ", 8, _hoisted_152)
                                ], 32),
                                _createElementVNode("div", _hoisted_153, [
                                  _cache[164] || (_cache[164] = _createElementVNode("h2", null, "Matching Notes", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deployStartNotes, (note) => {
                                    return (_openBlock(), _createElementBlock("article", {
                                      key: note.id,
                                      class: "soft-card note-card"
                                    }, [
                                      _createElementVNode("strong", null, _toDisplayString(note.title), 1),
                                      _createElementVNode("p", null, _toDisplayString(note.content), 1)
                                    ]))
                                  }), 128)),
                                  (!_ctx.deployStartNotes.length)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_154, " No matching notes. "))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                        ]))
                      : (_ctx.screen === 'history')
                        ? (_openBlock(), _createElementBlock("section", _hoisted_155, [
                            _createElementVNode("div", _hoisted_156, [
                              _createElementVNode("div", _hoisted_157, [
                                _cache[168] || (_cache[168] = _createElementVNode("h2", null, "Search and Filter", -1)),
                                _createElementVNode("label", null, [
                                  _cache[165] || (_cache[165] = _createTextVNode(" Search ", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.historySearch) = $event)),
                                    placeholder: "Search by customer, version, target version, or user"
                                  }, null, 512), [
                                    [
                                      _vModelText,
                                      _ctx.historySearch,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                                ]),
                                _createElementVNode("label", null, [
                                  _cache[167] || (_cache[167] = _createTextVNode(" Status ", -1)),
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.historyStatusFilter) = $event))
                                  }, [...(_cache[166] || (_cache[166] = [
                                    _createElementVNode("option", { value: "all" }, "all", -1),
                                    _createElementVNode("option", { value: "completed" }, "completed", -1),
                                    _createElementVNode("option", { value: "in-progress" }, "in-progress", -1),
                                    _createElementVNode("option", { value: "not-started" }, "not-started", -1)
                                  ]))], 512), [
                                    [_vModelSelect, _ctx.historyStatusFilter]
                                  ])
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: _cache[72] || (_cache[72] = 
//@ts-ignore
(...args) => (_ctx.exportFilteredHistoryCsv && _ctx.exportFilteredHistoryCsv(...args)))
                                }, " Export Filtered CSV ")
                              ]),
                              (_ctx.selectedHistoryDeployment)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_158, [
                                    _createElementVNode("div", _hoisted_159, [
                                      _cache[169] || (_cache[169] = _createElementVNode("h2", null, "Deployment Detail", -1)),
                                      _createElementVNode("span", _hoisted_160, _toDisplayString(_ctx.getProgress(_ctx.selectedHistoryDeployment).status), 1)
                                    ]),
                                    _createElementVNode("p", null, [
                                      _cache[170] || (_cache[170] = _createElementVNode("strong", null, "Customer:", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.selectedHistoryDeployment.customerName), 1)
                                    ]),
                                    _createElementVNode("p", null, [
                                      _cache[171] || (_cache[171] = _createElementVNode("strong", null, "Versions:", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.selectedHistoryDeployment.currentVersion) + " -> " + _toDisplayString(_ctx.selectedHistoryDeployment.targetVersion), 1)
                                    ]),
                                    _createElementVNode("p", null, [
                                      _cache[172] || (_cache[172] = _createElementVNode("strong", null, "User:", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.getUserLabel(_ctx.selectedHistoryDeployment.userId)), 1)
                                    ]),
                                    _createElementVNode("p", null, [
                                      _cache[173] || (_cache[173] = _createElementVNode("strong", null, "Date:", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.selectedHistoryDeployment.createdAt), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_161, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "ghost",
                                        onClick: _cache[73] || (_cache[73] = ($event: any) => (_ctx.resumeDeployment(_ctx.selectedHistoryDeployment.id)))
                                      }, " Resume "),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "ghost",
                                        onClick: _cache[74] || (_cache[74] = ($event: any) => (_ctx.exportDeploymentCsv(_ctx.selectedHistoryDeployment.id)))
                                      }, " Export CSV "),
                                      _createElementVNode("button", {
                                        type: "button",
                                        onClick: _cache[75] || (_cache[75] = ($event: any) => (_ctx.printDeployment(_ctx.selectedHistoryDeployment.id)))
                                      }, " Print / PDF ")
                                    ]),
                                    (_ctx.getDeploymentGroups(_ctx.selectedHistoryDeployment).length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDeploymentGroups(_ctx.selectedHistoryDeployment), (group) => {
                                            return (_openBlock(), _createElementBlock("details", {
                                              key: group.key,
                                              open: "",
                                              class: "details-panel"
                                            }, [
                                              _createElementVNode("summary", null, _toDisplayString(group.unitName), 1),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.sections, (section) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: section.key,
                                                  class: "stack"
                                                }, [
                                                  _createElementVNode("h3", null, _toDisplayString(section.sectionName), 1),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.steps, (step) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      key: step.state.stepId,
                                                      class: "soft-card"
                                                    }, [
                                                      _createElementVNode("strong", null, _toDisplayString(step.stepName), 1),
                                                      _createElementVNode("p", _hoisted_163, _toDisplayString(step.state.completed ? "Completed" : "Pending"), 1),
                                                      _createElementVNode("p", null, _toDisplayString(step.state.notes || "No notes"), 1)
                                                    ]))
                                                  }), 128))
                                                ]))
                                              }), 128))
                                            ]))
                                          }), 128))
                                        ]))
                                      : (_openBlock(), _createElementBlock("p", _hoisted_164, "This deployment has no steps."))
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_165, [
                              _cache[175] || (_cache[175] = _createElementVNode("h2", null, "Deployments", -1)),
                              _createElementVNode("table", _hoisted_166, [
                                _cache[174] || (_cache[174] = _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, "Customer"),
                                    _createElementVNode("th", null, "Current"),
                                    _createElementVNode("th", null, "Target"),
                                    _createElementVNode("th", null, "User"),
                                    _createElementVNode("th", null, "Date"),
                                    _createElementVNode("th", null, "Progress"),
                                    _createElementVNode("th", null, "Status"),
                                    _createElementVNode("th", null, "Actions")
                                  ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredHistoryRows, (deployment) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: deployment.id
                                    }, [
                                      _createElementVNode("td", null, _toDisplayString(deployment.customerName), 1),
                                      _createElementVNode("td", null, _toDisplayString(deployment.currentVersion), 1),
                                      _createElementVNode("td", null, _toDisplayString(deployment.targetVersion), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.getUserLabel(deployment.userId)), 1),
                                      _createElementVNode("td", null, _toDisplayString(deployment.createdAt.slice(0, 10)), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.getProgress(deployment).completed) + "/" + _toDisplayString(_ctx.getProgress(deployment).total) + " (" + _toDisplayString(_ctx.getProgress(deployment).percentage) + "%) ", 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.getProgress(deployment).status), 1),
                                      _createElementVNode("td", _hoisted_167, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "ghost",
                                          onClick: ($event: any) => (_ctx.selectHistoryDeployment(deployment.id))
                                        }, " Inspect ", 8, _hoisted_168),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "ghost",
                                          onClick: ($event: any) => (_ctx.resumeDeployment(deployment.id))
                                        }, " Resume ", 8, _hoisted_169),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "ghost",
                                          onClick: ($event: any) => (_ctx.exportDeploymentCsv(deployment.id))
                                        }, " CSV ", 8, _hoisted_170),
                                        _createElementVNode("button", {
                                          type: "button",
                                          onClick: ($event: any) => (_ctx.printDeployment(deployment.id))
                                        }, " Print ", 8, _hoisted_171)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]))
                        : (_ctx.screen === 'branches')
                          ? (_openBlock(), _createElementBlock("section", _hoisted_172, [
                              _createElementVNode("form", {
                                class: "card stack",
                                onSubmit: _cache[79] || (_cache[79] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitBranch && _ctx.submitBranch(...args)), ["prevent"]))
                              }, [
                                _createElementVNode("div", _hoisted_173, [
                                  _createElementVNode("h2", null, _toDisplayString(_ctx.branchForm.id ? "Edit Branch" : "Create Branch"), 1),
                                  (_ctx.branchForm.id)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "ghost",
                                        onClick: _cache[76] || (_cache[76] = 
//@ts-ignore
(...args) => (_ctx.resetBranchForm && _ctx.resetBranchForm(...args)))
                                      }, " Clear "))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("label", null, [
                                  _cache[176] || (_cache[176] = _createTextVNode(" Branch Name ", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.branchForm.name) = $event)),
                                    required: ""
                                  }, null, 512), [
                                    [
                                      _vModelText,
                                      _ctx.branchForm.name,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                                ]),
                                _createElementVNode("label", null, [
                                  _cache[177] || (_cache[177] = _createTextVNode(" Starting Iteration ", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.branchForm.startingIteration) = $event)),
                                    type: "number",
                                    min: "0",
                                    required: ""
                                  }, null, 512), [
                                    [
                                      _vModelText,
                                      _ctx.branchForm.startingIteration,
                                      void 0,
                                      { number: true }
                                    ]
                                  ])
                                ]),
                                _createElementVNode("button", _hoisted_174, _toDisplayString(_ctx.branchForm.id ? "Update Branch" : "Save Branch"), 1)
                              ], 32),
                              _createElementVNode("div", _hoisted_175, [
                                _cache[179] || (_cache[179] = _createElementVNode("h2", null, "Branches", -1)),
                                _createElementVNode("table", _hoisted_176, [
                                  _cache[178] || (_cache[178] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", null, "Name"),
                                      _createElementVNode("th", null, "Starting"),
                                      _createElementVNode("th", null, "Prod"),
                                      _createElementVNode("th", null, "Dev"),
                                      _createElementVNode("th", null, "Actions")
                                    ])
                                  ], -1)),
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedBranches, (branch) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: branch.id
                                      }, [
                                        _createElementVNode("td", null, _toDisplayString(branch.name), 1),
                                        _createElementVNode("td", null, _toDisplayString(branch.startingIteration), 1),
                                        _createElementVNode("td", null, _toDisplayString(branch.prodIteration), 1),
                                        _createElementVNode("td", null, _toDisplayString(branch.devIteration), 1),
                                        _createElementVNode("td", _hoisted_177, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "ghost",
                                            onClick: ($event: any) => (_ctx.editBranch(branch))
                                          }, " Edit ", 8, _hoisted_178),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "danger",
                                            onClick: ($event: any) => (_ctx.removeBranch(branch.id))
                                          }, " Delete ", 8, _hoisted_179)
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ]))
                          : (_ctx.screen === 'applications')
                            ? (_openBlock(), _createElementBlock("section", _hoisted_180, [
                                _createElementVNode("div", _hoisted_181, [
                                  _createElementVNode("form", {
                                    class: "card stack",
                                    onSubmit: _cache[81] || (_cache[81] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitApplication && _ctx.submitApplication(...args)), ["prevent"]))
                                  }, [
                                    _cache[181] || (_cache[181] = _createElementVNode("h2", null, "Create Application", -1)),
                                    _createElementVNode("label", null, [
                                      _cache[180] || (_cache[180] = _createTextVNode(" Name ", -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((_ctx.applicationName) = $event)),
                                        required: ""
                                      }, null, 512), [
                                        [
                                          _vModelText,
                                          _ctx.applicationName,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ])
                                    ]),
                                    _cache[182] || (_cache[182] = _createElementVNode("button", { type: "submit" }, "Save Application", -1))
                                  ], 32),
                                  _createElementVNode("form", {
                                    class: "card stack",
                                    onSubmit: _cache[85] || (_cache[85] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitApplicationProperty && _ctx.submitApplicationProperty(...args)), ["prevent"]))
                                  }, [
                                    _createElementVNode("div", _hoisted_182, [
                                      _createElementVNode("h2", null, _toDisplayString(_ctx.applicationPropertyForm.id ? "Edit Property" : "Create Property"), 1),
                                      (_ctx.applicationPropertyForm.id)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            type: "button",
                                            class: "ghost",
                                            onClick: _cache[82] || (_cache[82] = 
//@ts-ignore
(...args) => (_ctx.resetApplicationPropertyForm && _ctx.resetApplicationPropertyForm(...args)))
                                          }, " Clear "))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("label", null, [
                                      _cache[183] || (_cache[183] = _createTextVNode(" Name ", -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => ((_ctx.applicationPropertyForm.name) = $event)),
                                        required: ""
                                      }, null, 512), [
                                        [
                                          _vModelText,
                                          _ctx.applicationPropertyForm.name,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ])
                                    ]),
                                    _createElementVNode("label", null, [
                                      _cache[185] || (_cache[185] = _createTextVNode(" Type ", -1)),
                                      _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.applicationPropertyForm.type) = $event)),
                                        required: ""
                                      }, [...(_cache[184] || (_cache[184] = [
                                        _createElementVNode("option", { value: "text" }, "text", -1),
                                        _createElementVNode("option", { value: "number" }, "number", -1),
                                        _createElementVNode("option", { value: "date" }, "date", -1),
                                        _createElementVNode("option", { value: "boolean" }, "boolean", -1)
                                      ]))], 512), [
                                        [_vModelSelect, _ctx.applicationPropertyForm.type]
                                      ])
                                    ]),
                                    _createElementVNode("button", _hoisted_183, _toDisplayString(_ctx.applicationPropertyForm.id ? "Update Property" : "Save Property"), 1)
                                  ], 32)
                                ]),
                                _createElementVNode("div", _hoisted_184, [
                                  _cache[188] || (_cache[188] = _createElementVNode("h2", null, "Applications", -1)),
                                  _createElementVNode("table", _hoisted_185, [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", null, [
                                        _cache[186] || (_cache[186] = _createElementVNode("th", null, "Application", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedApplicationProperties, (property) => {
                                          return (_openBlock(), _createElementBlock("th", {
                                            key: property.id
                                          }, _toDisplayString(property.name), 1))
                                        }), 128)),
                                        _cache[187] || (_cache[187] = _createElementVNode("th", null, "Actions", -1))
                                      ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedApplications, (application) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: application.id
                                        }, [
                                          _createElementVNode("td", null, [
                                            _createElementVNode("input", {
                                              value: application.name,
                                              onInput: ($event: any) => (_ctx.renameApplication(application.id, _ctx.eventValue($event)))
                                            }, null, 40, _hoisted_186)
                                          ]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedApplicationProperties, (property) => {
                                            return (_openBlock(), _createElementBlock("td", {
                                              key: `${application.id}-${property.id}`
                                            }, [
                                              (property.type === 'text')
                                                ? (_openBlock(), _createElementBlock("input", {
                                                    key: 0,
                                                    value: String(application.propertyValues[property.id] ?? ''),
                                                    onInput: ($event: any) => (
                    _ctx.setApplicationValue(
                      application.id,
                      property.id,
                      _ctx.eventValue($event)
                    )
                  )
                                                  }, null, 40, _hoisted_187))
                                                : (property.type === 'number')
                                                  ? (_openBlock(), _createElementBlock("input", {
                                                      key: 1,
                                                      value: String(application.propertyValues[property.id] ?? ''),
                                                      type: "number",
                                                      onInput: ($event: any) => (
                    _ctx.setApplicationValue(
                      application.id,
                      property.id,
                      _ctx.eventValue($event)
                    )
                  )
                                                    }, null, 40, _hoisted_188))
                                                  : (property.type === 'date')
                                                    ? (_openBlock(), _createElementBlock("input", {
                                                        key: 2,
                                                        value: String(application.propertyValues[property.id] ?? ''),
                                                        type: "date",
                                                        onInput: ($event: any) => (
                    _ctx.setApplicationValue(
                      application.id,
                      property.id,
                      _ctx.eventValue($event)
                    )
                  )
                                                      }, null, 40, _hoisted_189))
                                                    : (_openBlock(), _createElementBlock("input", {
                                                        key: 3,
                                                        checked: Boolean(application.propertyValues[property.id]),
                                                        type: "checkbox",
                                                        onChange: ($event: any) => (
                    _ctx.setApplicationValue(
                      application.id,
                      property.id,
                      _ctx.eventChecked($event)
                    )
                  )
                                                      }, null, 40, _hoisted_190))
                                            ]))
                                          }), 128)),
                                          _createElementVNode("td", _hoisted_191, [
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "danger",
                                              onClick: ($event: any) => (_ctx.removeApplication(application.id))
                                            }, " Delete ", 8, _hoisted_192)
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_193, [
                                  _cache[190] || (_cache[190] = _createElementVNode("h2", null, "Application Properties", -1)),
                                  _createElementVNode("table", _hoisted_194, [
                                    _cache[189] || (_cache[189] = _createElementVNode("thead", null, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("th", null, "Name"),
                                        _createElementVNode("th", null, "Type"),
                                        _createElementVNode("th", null, "Actions")
                                      ])
                                    ], -1)),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedApplicationProperties, (property) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: property.id
                                        }, [
                                          _createElementVNode("td", null, _toDisplayString(property.name), 1),
                                          _createElementVNode("td", null, _toDisplayString(property.type), 1),
                                          _createElementVNode("td", _hoisted_195, [
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "ghost",
                                              onClick: ($event: any) => (_ctx.editApplicationProperty(property))
                                            }, " Edit ", 8, _hoisted_196),
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "danger",
                                              onClick: ($event: any) => (_ctx.removeApplicationProperty(property.id))
                                            }, " Delete ", 8, _hoisted_197)
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ]))
                            : (_ctx.screen === 'docs')
                              ? (_openBlock(), _createElementBlock("section", _hoisted_198, [
                                  _cache[191] || (_cache[191] = _createElementVNode("div", { class: "split" }, [
                                    _createElementVNode("h2", null, "Specification Reference"),
                                    _createElementVNode("span", { class: "muted" }, "Loaded from the repository documentation source")
                                  ], -1)),
                                  _createElementVNode("pre", _hoisted_199, _toDisplayString(_ctx.docsContent), 1)
                                ]))
                              : _createCommentVNode("", true)
  ]))
}